/** Full list of supported fiat currencies with metadata for SEO and display */
export interface CurrencyInfo {
  code: string;
  name: string;
  symbol: string;
  slug: string; // URL slug: "satoshis-to-usd-converter"
}

export const CURRENCIES: CurrencyInfo[] = [
  {
    code: "aed",
    name: "United Arab Emirates Dirham",
    symbol: "د.إ",
    slug: "satoshis-to-aed-converter",
  },
  {
    code: "ars",
    name: "Argentine Peso",
    symbol: "$",
    slug: "satoshis-to-ars-converter",
  },
  {
    code: "aud",
    name: "Australian Dollar",
    symbol: "A$",
    slug: "satoshis-to-aud-converter",
  },
  {
    code: "bdt",
    name: "Bangladeshi Taka",
    symbol: "৳",
    slug: "satoshis-to-bdt-converter",
  },
  {
    code: "bhd",
    name: "Bahraini Dinar",
    symbol: ".د.ب",
    slug: "satoshis-to-bhd-converter",
  },
  {
    code: "bmd",
    name: "Bermudian Dollar",
    symbol: "$",
    slug: "satoshis-to-bmd-converter",
  },
  {
    code: "brl",
    name: "Brazilian Real",
    symbol: "R$",
    slug: "satoshis-to-brl-converter",
  },
  {
    code: "cad",
    name: "Canadian Dollar",
    symbol: "C$",
    slug: "satoshis-to-cad-converter",
  },
  {
    code: "chf",
    name: "Swiss Franc",
    symbol: "CHF",
    slug: "satoshis-to-chf-converter",
  },
  {
    code: "clp",
    name: "Chilean Peso",
    symbol: "$",
    slug: "satoshis-to-clp-converter",
  },
  {
    code: "cny",
    name: "Chinese Yuan",
    symbol: "¥",
    slug: "satoshis-to-cny-converter",
  },
  {
    code: "czk",
    name: "Czech Koruna",
    symbol: "Kč",
    slug: "satoshis-to-czk-converter",
  },
  {
    code: "dkk",
    name: "Danish Krone",
    symbol: "kr",
    slug: "satoshis-to-dkk-converter",
  },
  { code: "eur", name: "Euro", symbol: "€", slug: "satoshis-to-eur-converter" },
  {
    code: "gbp",
    name: "British Pound Sterling",
    symbol: "£",
    slug: "satoshis-to-gbp-converter",
  },
  {
    code: "gel",
    name: "Georgian Lari",
    symbol: "₾",
    slug: "satoshis-to-gel-converter",
  },
  {
    code: "hkd",
    name: "Hong Kong Dollar",
    symbol: "HK$",
    slug: "satoshis-to-hkd-converter",
  },
  {
    code: "huf",
    name: "Hungarian Forint",
    symbol: "Ft",
    slug: "satoshis-to-huf-converter",
  },
  {
    code: "idr",
    name: "Indonesian Rupiah",
    symbol: "Rp",
    slug: "satoshis-to-idr-converter",
  },
  {
    code: "ils",
    name: "Israeli New Shekel",
    symbol: "₪",
    slug: "satoshis-to-ils-converter",
  },
  {
    code: "inr",
    name: "Indian Rupee",
    symbol: "₹",
    slug: "satoshis-to-inr-converter",
  },
  {
    code: "jpy",
    name: "Japanese Yen",
    symbol: "¥",
    slug: "satoshis-to-jpy-converter",
  },
  {
    code: "krw",
    name: "South Korean Won",
    symbol: "₩",
    slug: "satoshis-to-krw-converter",
  },
  {
    code: "kwd",
    name: "Kuwaiti Dinar",
    symbol: "د.ك",
    slug: "satoshis-to-kwd-converter",
  },
  {
    code: "lkr",
    name: "Sri Lankan Rupee",
    symbol: "Rs",
    slug: "satoshis-to-lkr-converter",
  },
  {
    code: "mmk",
    name: "Myanmar Kyat",
    symbol: "K",
    slug: "satoshis-to-mmk-converter",
  },
  {
    code: "mxn",
    name: "Mexican Peso",
    symbol: "MX$",
    slug: "satoshis-to-mxn-converter",
  },
  {
    code: "myr",
    name: "Malaysian Ringgit",
    symbol: "RM",
    slug: "satoshis-to-myr-converter",
  },
  {
    code: "ngn",
    name: "Nigerian Naira",
    symbol: "₦",
    slug: "satoshis-to-ngn-converter",
  },
  {
    code: "nok",
    name: "Norwegian Krone",
    symbol: "kr",
    slug: "satoshis-to-nok-converter",
  },
  {
    code: "nzd",
    name: "New Zealand Dollar",
    symbol: "NZ$",
    slug: "satoshis-to-nzd-converter",
  },
  {
    code: "php",
    name: "Philippine Peso",
    symbol: "₱",
    slug: "satoshis-to-php-converter",
  },
  {
    code: "pkr",
    name: "Pakistani Rupee",
    symbol: "₨",
    slug: "satoshis-to-pkr-converter",
  },
  {
    code: "pln",
    name: "Polish Zloty",
    symbol: "zł",
    slug: "satoshis-to-pln-converter",
  },
  {
    code: "rub",
    name: "Russian Ruble",
    symbol: "₽",
    slug: "satoshis-to-rub-converter",
  },
  {
    code: "sar",
    name: "Saudi Riyal",
    symbol: "﷼",
    slug: "satoshis-to-sar-converter",
  },
  {
    code: "sek",
    name: "Swedish Krona",
    symbol: "kr",
    slug: "satoshis-to-sek-converter",
  },
  {
    code: "sgd",
    name: "Singapore Dollar",
    symbol: "S$",
    slug: "satoshis-to-sgd-converter",
  },
  {
    code: "thb",
    name: "Thai Baht",
    symbol: "฿",
    slug: "satoshis-to-thb-converter",
  },
  {
    code: "try",
    name: "Turkish Lira",
    symbol: "₺",
    slug: "satoshis-to-try-converter",
  },
  {
    code: "twd",
    name: "New Taiwan Dollar",
    symbol: "NT$",
    slug: "satoshis-to-twd-converter",
  },
  {
    code: "uah",
    name: "Ukrainian Hryvnia",
    symbol: "₴",
    slug: "satoshis-to-uah-converter",
  },
  {
    code: "usd",
    name: "United States Dollar",
    symbol: "$",
    slug: "satoshis-to-usd-converter",
  },
  {
    code: "vef",
    name: "Venezuelan Bolívar",
    symbol: "Bs.F",
    slug: "satoshis-to-vef-converter",
  },
  {
    code: "vnd",
    name: "Vietnamese Dong",
    symbol: "₫",
    slug: "satoshis-to-vnd-converter",
  },
  {
    code: "zar",
    name: "South African Rand",
    symbol: "R",
    slug: "satoshis-to-zar-converter",
  },
];

export const CURRENCY_BY_CODE: Record<string, CurrencyInfo> =
  Object.fromEntries(CURRENCIES.map((c) => [c.code, c]));

export const CURRENCY_BY_SLUG: Record<string, CurrencyInfo> =
  Object.fromEntries(CURRENCIES.map((c) => [c.slug, c]));

/** All valid converter base slugs for matching in AppContainer */
const BASE_CONVERTER_SLUGS = new Set(CURRENCIES.map((c) => "/" + c.slug));

/** Check whether a path is a converter page (with or without a language suffix) */
export function isConverterPath(path: string): boolean {
  if (BASE_CONVERTER_SLUGS.has(path)) return true;
  // Check for /satoshis-to-xxx-converter/lang-slug pattern
  const lastSlash = path.lastIndexOf("/");
  if (lastSlash > 0) {
    const basePath = path.substring(0, lastSlash);
    return BASE_CONVERTER_SLUGS.has(basePath);
  }
  return false;
}

/** @deprecated Use isConverterPath() instead */
export const CONVERTER_SLUGS = BASE_CONVERTER_SLUGS;

export const SATS_PER_BTC = 100_000_000;
